import styled from 'styled-components';
import SVGIcon from '../../../atomic/atoms/SVGIcon';
import { Flex } from '../../../Utils/styles/display';
import ThemeV2 from '../../../theme';

export const Container = styled.div`
  display: inline-flex;
`;

export const BoardTitle = styled(Flex)`
  padding: 16px;
  border-radius: 4px;
  background: ${ThemeV2.palette.gray3};
  min-width: 272px;
  margin-top: 12px;
  margin-left: 12px;
`;

export const PlusIcon = styled(SVGIcon)`
  margin-right: 8px;
`;
